import { render, staticRenderFns } from "./DefaultSeller.vue?vue&type=template&id=1c8dc474&scoped=true"
import script from "./DefaultSeller.vue?vue&type=script&lang=js"
export * from "./DefaultSeller.vue?vue&type=script&lang=js"
import style0 from "./DefaultSeller.vue?vue&type=style&index=0&id=1c8dc474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8dc474",
  null
  
)

export default component.exports